import { render, staticRenderFns } from "./FavRegions.vue?vue&type=template&id=091acd14&scoped=true"
import script from "./FavRegions.vue?vue&type=script&lang=js"
export * from "./FavRegions.vue?vue&type=script&lang=js"
import style0 from "./FavRegions.vue?vue&type=style&index=0&id=091acd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091acd14",
  null
  
)

export default component.exports